import React, { ChangeEvent, CSSProperties, useState } from "react";

interface TextInputProps {
  label?: string;
  name?: string;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  Component?: string;
  maxLength?: number;
  required?: boolean;
  className?: string;
  style?: CSSProperties;
  type?: string;
  spacesTrim?: boolean; 
}

const TextInputTypeField: React.FC<TextInputProps> = ({
  label,
  name,
  value,
  onChange,
  error = "",
  touched = false,
  disabled = false,
  Component = "",
  maxLength,
  required = false,
  className = "",
  style = {},
  type = "text",
  spacesTrim = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  // Determine the input type (dynamic type or toggled password type)
  const inputType = type === "password" && showPassword ? "text" : type;

  const handleTogglePassword = () => {
    if (!disabled) {
      setShowPassword(!showPassword);
    }
  };

  // Handle input change with spacesTrim logic
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let inputValue = event.target.value;

    // If spacesTrim is true, remove all spaces
    if (spacesTrim) {
      inputValue = inputValue.replace(/\s+/g, "");
    }

    // Call the parent's onChange with the processed value
    if (onChange) {
      onChange({
        ...event,
        target: {
          ...event.target,
          value: inputValue,
        },
      });
    }
  };

  return (
    <div className={`mb-0 ${className}`} style={style}>
      <div className="form-floating position-relative">
        <input
          type={inputType}
          className={`form-control ${touched && error ? "is-invalid" : ""}`}
          id={`txt${Component}${name}`}
          name={name}
          value={value}
          onChange={handleChange}
          placeholder=" "
          disabled={disabled}
          maxLength={maxLength}
        />
        <label htmlFor={`txt${Component}${name}`}>
          {label}
          {!disabled && required && <span style={{ color: "red" }}>*</span>}
        </label>
        {touched && error && <div className="invalid-feedback">{error}</div>}

        {/* Eye icon for toggling password visibility */}
        {/* {type === "password" && (
          <span
            className="position-absolute"
            style={{
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: disabled ? "default" : "pointer",
              color: disabled ? "gray" : "inherit",
            }}
            onClick={handleTogglePassword} 
          >
            {showPassword ? "👁️" : "🔒"} 
          </span>
        )} */}
      </div>
    </div>
  );
};

export default TextInputTypeField;
